import { apiService } from "api/apiService";
import type { PortfolioAbilitiesResource } from "api/generated";
import { portfolioAbilitiesFromDto } from "portfolio/api/mappers";
import type { PortfolioAbilities } from "portfolio/types";

export const fetchPortfolioAbilities =
  async (): Promise<PortfolioAbilities> => {
    const {
      data: { data: abilities },
    } = await apiService.get<{ data: PortfolioAbilitiesResource }>(
      "api/portfolio/abilities",
    );

    return portfolioAbilitiesFromDto(abilities);
  };
